"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = {
    id: 'xray',
    name: 'X-Ray',
    background_color: '#000000',
    background_image: 'https://assets.raydiant.com/images/xray.svg',
    background_image_portrait: 'https://assets.raydiant.com/images/xray-portrait.svg',
    heading_font: 'https://fonts.raydiant.com/Poppins-Bold.woff',
    heading_text_color: '#f9f613',
    heading_2_font: 'https://fonts.raydiant.com/Roboto-Bold.woff',
    heading_2_text_color: '#ffffff',
    body_font: 'https://fonts.raydiant.com/Arimo-Regular.woff',
    body_text_color: '#f6f6f6',
    border_color: '#f9f613',
};
//# sourceMappingURL=xray.js.map


// WEBPACK FOOTER //
// ../raydiant-kit/lib/themes/xray.js